import { ACTION_TYPE } from '../../util/GlobalData'
import client from '../../util/sanity';

const ProductDetailAction = (id) => async (dispatch) => {
    await dispatch({
        type: ACTION_TYPE.LOADING,
        payload: true
    })
    try {
        const data = await client.fetch('*[_type == "products" && _id == $id]', { id });;
        await dispatch({
            type: ACTION_TYPE.PRODUCTS_DETAILS,
            payload: data,
        })
        dispatch({
            type: ACTION_TYPE.LOADING,
            payload: false
        })
    } catch (error) {
        console.log(error);
        dispatch({
            type: ACTION_TYPE.FAILED,
            error: 'Failed to fetch Sanity data',
        });
    }
}

export default ProductDetailAction